import { render, staticRenderFns } from "./arts-and-heritage.vue?vue&type=template&id=687d060c&"
import script from "./arts-and-heritage.vue?vue&type=script&lang=js&"
export * from "./arts-and-heritage.vue?vue&type=script&lang=js&"
import style0 from "./arts-and-heritage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports